import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const TableSearchBar = ({ placeholder, onSearch, value }) => {
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  /**
   * Store the input value in state
   *
   * @param {Any} event
   */
  const captureInputValue = (event) => {
    setInputValue(event.target.value);
    if (event.target.value === '') {
      onSearch('');
    }
  };

  return (
    <div className="input-group mb-3">
      <input
        type="search"
        className="form-control"
        placeholder={placeholder}
        onChange={captureInputValue}
        value={inputValue}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            onSearch(inputValue);
          }
        }}
      />
      <button
        onClick={() => {
          onSearch(inputValue);
        }}
        className="btn btn-outline-secondary table-search-end-button"
        type="button"
      >
        Search
      </button>
    </div>
  );
};

TableSearchBar.propTypes = {
  placeholder: PropTypes.string,
  onSearch: PropTypes.func,
  value: PropTypes.string,
};

export default TableSearchBar;
